const defaults = {nonTextBehavior: 'remove'}

export const blocksToText = (blocks?: null | Array<{_type: string, children: Array<{text: string}>}>, opts = defaults) => {
  if (!blocks) return ''
  return blocks
    .map(block => {
      if (block._type !== 'block' || !block.children) {
        return opts.nonTextBehavior === 'remove' ? '' : `[${block._type} block]`
      }

      return block.children.map(child => child.text).join('')
    })
    .join('\n\n')
}
